import type { VFC } from 'react'
import { Tooltip, Badge } from '@panwds/react-ui'
import type { NavItem, NavBadgeProps, IconBadgeProps, ValueBadgeProps } from '../../framework/microAppTypes'
import { BadgeType } from '../../framework/enums'

const NAV_BADGE_ROUND_UP_NUMBER = 99

const NavBadge : VFC<{navItem: NavItem}> = ({ navItem }) => {
  const navBadgeProps = navItem.badgeProps as NavBadgeProps | undefined
  // const size = (badgeProps.size || 'xs') as 'xs' | 'sm' | 'md' | 'lg'
  if (navBadgeProps) {
    const { type, badgeProps, tooltip, tooltipPlacement } = navBadgeProps
    const getBadge = () => {
      switch (type) {
        case BadgeType.ICON: {
          const displayValue = (badgeProps as IconBadgeProps)?.icon
          return <Badge appearance={'red'} overrideAppearance={'spf-bg-transparent spf-pr-[0px]'}>
            <div className='spf-pl-[12px] sparky-nav-icon-badge'>
              {displayValue}
            </div>
          </Badge>
        }
        case BadgeType.VALUE: {
          const size = ((badgeProps as ValueBadgeProps).size || 'xs') as 'xs' | 'sm' | 'md' | 'lg'
          const shape = ((badgeProps as ValueBadgeProps).shape || 'square') as 'square' | 'circle'
          const color = ((badgeProps as ValueBadgeProps).color || 'red') as 'red' | 'blue' | 'teal' | 'lightBlue'
          const textColor = (badgeProps as ValueBadgeProps).textColor as 'dark' | 'light' | undefined
          const displayValue = ((badgeProps as ValueBadgeProps)?.value as any > NAV_BADGE_ROUND_UP_NUMBER ? `${NAV_BADGE_ROUND_UP_NUMBER}+` : String((badgeProps as ValueBadgeProps)?.value))
          return <Badge appearance={color} shape={shape} size={size} textColor={textColor}>
            <div className='spf-pr-1'>
              {displayValue}
            </div>
          </Badge>
        }
        default:
          return null
      }
    }
    const badge = tooltip ?
      <Tooltip label={tooltip} defaultPlacement={tooltipPlacement as any || 'right'}>
        {getBadge()}
      </Tooltip> : getBadge()
    return badge
  }
  else {
    return <></>
  }

}

export default NavBadge
